import React from 'react';
import copy from 'copy-to-clipboard';
import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import IconButton from '@material-ui/core/IconButton';
import Icon from '@material-ui/core/Icon';

const styles = {
  wrapper: {
    display: 'flex',
    alignItems: 'center',
  },
  textField: {
    flex: 1,
  }
}

const CopyToClipboard = ({ text, classes }) => {
  return (
    <div className={classes.wrapper}>
      <TextField
        label="Link"
        value={text}
        disabled
        fullWidth
        className={classes.textField}
      />
      <IconButton aria-label="copy" onClick={() => copy(text)}>
        <Icon>file_copy</Icon>
      </IconButton>
    </div>
  );
}

export default withStyles(styles)(CopyToClipboard);



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/components/CopyToClipboard/index.js